export const Philosophy = () => (
  <section id="philosophy" className="bg-stone-900 text-stone-100 py-32 relative overflow-hidden" data-testid="philosophy-section">
    <div className="lantern-glow absolute w-[34rem] h-[34rem] rounded-full -right-40 -top-40 opacity-60" />
    <div className="max-w-4xl mx-auto px-6 relative">
      <p className="font-serif-display text-3xl sm:text-4xl leading-snug italic">
        Made to be opened slowly, enjoyed at your own pace and perhaps kept long after the month is over.
      </p>
      <p className="mt-12 text-base sm:text-lg text-stone-300 leading-relaxed max-w-2xl">
        No homework. No pressure. Just thoughtful little things to remind you that life is happening in the in-between, too.
      </p>
      <p className="font-hand text-3xl sm:text-4xl text-amber-300 mt-16 -rotate-1" data-testid="philosophy-closing">
        One envelope. A whole lot of little things. A little light, delivered monthly.
      </p>
    </div>
  </section>
);
